module.exports = __webpack_public_path__ + "static/media/netgateFw.80f2d294.jpg";